/**
 * Converts a File object to a base64 encoded string (without the data URL prefix)
 */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      // Remove the data URL prefix (e.g., "data:image/png;base64,")
      const base64 = (reader.result as string).split(',')[1]
      resolve(base64)
    }
    reader.onerror = (error) => reject(error)
  })
}

/**
 * Gets the MIME type from a File object
 */
export function getContentType(file: File): string {
  return file.type || 'application/octet-stream'
}
